module.exports = __webpack_public_path__ + "static/img/zbjt.9288182.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zbjt.png
// module id = UK6l
// module chunks = 0